import { render, staticRenderFns } from "./PixPagamento.vue?vue&type=template&id=676a9e5b&scoped=true"
import script from "./PixPagamento.vue?vue&type=script&lang=js"
export * from "./PixPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676a9e5b",
  null
  
)

export default component.exports